var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23226 3.35925C3.42225 3.1316 3.70348 3 4.00001 3H16C16.5523 3 17 3.44772 17 4V14.8889L18.1006 19.7805C18.1673 20.0769 18.0956 20.3875 17.9059 20.6247C17.7161 20.8619 17.4288 21 17.125 21H4.87501C4.57122 21 4.28391 20.8619 4.09414 20.6247C3.90437 20.3875 3.83271 20.0769 3.8994 19.7805L4.97977 14.9788L3.01614 4.17889C2.96309 3.88715 3.04226 3.58691 3.23226 3.35925ZM6.80001 16L6.12501 19H15.875L15.2 16H6.80001ZM15 14V5H5.19822L6.83458 14H15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4C15 3.44772 15.4477 3 16 3H18.4C18.9523 3 19.4 3.44772 19.4 4V6.80952H20C20.5523 6.80952 21 7.25724 21 7.80952V14C21 14.5523 20.5523 15 20 15H16C15.4477 15 15 14.5523 15 14V4ZM19 8.80952H18.4C17.8477 8.80952 17.4 8.36181 17.4 7.80952V5H17V13H19V8.80952Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfr);
export default __webpack_public_path__ + "static/media/mfr.24bf3c97db8b12be31750b851830632b.svg";
export { ForwardRef as ReactComponent };